import "./style.css";
import React, { useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import slugify from "../../Utils/slugify";
export default function BestProductCard({
  index,
  famille,
  article,
  categorie,
  subcategorie,
  subSubcategorie,
  prixPromo,
  prixFlash,
  prix,
  brand,
  stock
}) {
  // Animation au scroll
  useEffect(() => {
    const cards = document.querySelectorAll(".card-anim");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            anime({
              targets: entry.target,
              opacity: [0, 1],
              translateY: [40, 0],
              easing: "easeOutExpo",
              duration: 700,
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);
if (!article) return null;
  // Décomposition nom / catégorie
  const categoriee = article.split("-")[0];
  const articleName = article.split("-")[1];
  const articlImg = article.replace(/-/g, " ");

  // Construction du chemin de l'image
  let imagePath = "";
  let productLink = "";

  if (subSubcategorie) {
    productLink = `/produit/${slugify(famille)}/${slugify(categorie)}/${slugify(subcategorie)}/${slugify(subSubcategorie)}/${slugify(articleName)}`;
  } else if (subcategorie) {
    productLink = `/produit/${slugify(famille)}/${slugify(categorie)}/${slugify(subcategorie)}/${slugify(articleName)}`;
  } else {
    productLink = `/produit/${slugify(famille)}/${slugify(categoriee)}/${slugify(articleName)}`;
  }
    if (subSubcategorie) {
      imagePath = `${famille}/${categorie}/${subcategorie}/${subSubcategorie}/${articlImg}`;
    } else if (subcategorie) {
      imagePath = `${famille}/${categorie}/${subcategorie}/${articlImg}`;
    } else {
      imagePath = `${famille}/${categoriee}/${articlImg}`;
    }

  const imageUrl = `https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${encodeURIComponent(
    imagePath
  )}.jpeg?alt=media`;

  const discountPercent = prixPromo
    ? ((prix - prixPromo) / prix) * 100
    : prixFlash
    ? ((prix - prixFlash) / prix) * 100
    : 0;

  return (
    <div className="product-cardBest card-anim">

      {discountPercent > 0 && (
        <div className="badge promo">-{discountPercent.toFixed(0)}%</div>
      )}

      <a className="cardMediaLink" href={productLink}>
        <img src={imageUrl} alt={articleName} className="product-img" />
      </a>

      <div className="info">

        <h3 className="title">{articleName}</h3>
        <p className="desc">{brand}</p>

        <div className="price">
          {prixFlash ? (
            <>
              <span className="old-price">{prix.toFixed(3)} TND</span>
              <span className="new-price">{prixFlash.toFixed(3)} TND</span>
            </>
          ) : prixPromo ? (
            <>
              <span className="old-price">{prix.toFixed(3)} TND</span>
              <span className="new-price">{prixPromo.toFixed(3)} TND</span>
            </>
          ) : (
            <span className="new-price">{prix.toFixed(3)} TND</span>
          )}
        </div>

        {stock <= 0 && <p className="out-stock">En arrivage</p>}
      </div>
    </div>
  );
}
